const apiKey = "AIzaSyCEXcGaRVtHEKUJ7-6972y1pzAkAwdQDPY";
const URL = `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`

export const getTranslation = (text, language) => {
    return new Promise(function (success, error){
        const data = {q: text, target: language, format: "text"}
        fetch(URL, {
            method: 'POST',
            headers: {
             'content-type': 'application/json',
           },
            body: JSON.stringify(data)
         })
         .then((response) => response.json())
         .then((responseJson) => {
           success(responseJson);
         })
         .catch((e) => {
           console.log(e);
           error(e)
         });
    });
}